import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import {ListItemIcon, ListItemText, MenuItem} from '@mui/material';
import {Translation} from '../i18n/Translation';
import {ComponentWithoutChildren} from '../react/types';
import {useAppInstallFunctions} from './AppInstallFunctions';

export const AppInstallMenuItem: ComponentWithoutChildren = () => {
  const {installApp} = useAppInstallFunctions();

  if (!installApp) {
    return null;
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <MenuItem onClick={installApp}>
      <ListItemIcon>
        <InstallMobileIcon />
      </ListItemIcon>
      <Translation keys="main:pwa.prompt.title">{(text) => <ListItemText primary={text} />}</Translation>
    </MenuItem>
  );
};
